import React from 'react';
import { Layout } from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PublicLayout.css';

const { Header, Content, Footer } = Layout;

function PublicLayout({ children }) {
  const navigate = useNavigate();
  const { t } = useTranslation('public');

  return (
    <Layout className="public-layout">
      <Header className="public-header">
        <div className="public-header-content">
          <div
            className="public-logo-section"
            onClick={() => navigate('/catalogo')}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="/logo.svg"
              alt={t('layout.brandName')}
              className="public-logo"
            />
            <span className="public-brand-name">{t('layout.brandName')}</span>
          </div>
          <div className="public-header-actions">
            <a href="/onboarding" className="public-login-link">
              {t('layout.onboarding')}
            </a>
            <a href="/login" className="public-login-link">
              {t('layout.login')}
            </a>
          </div>
        </div>
      </Header>

      <Content className="public-content">
        <div className="public-content-wrapper">
          {children}
        </div>
      </Content>

      <Footer className="public-footer">
        <div className="public-footer-content">
          <p>{t('layout.copyright', { year: new Date().getFullYear() })}</p>
          <div className="public-footer-links">
            <a href="/catalogo">{t('layout.catalog')}</a>
            <a href="#">{t('layout.terms')}</a>
            <a href="#">{t('layout.privacy')}</a>
            <a href="#">{t('layout.contact')}</a>
          </div>
        </div>
      </Footer>
    </Layout>
  );
}

export default PublicLayout;
